import Rest from '../rest'

/******************************************************************************
 * Sales Table
 *****************************************************************************/

/**
 * @type {SalesTable}
 */
export default class SalesTable extends Rest {

    constructor () {
        super('/availability/tables')
    }

    /**
     * Busca todas as tabelas de vendas, vencidas ou não, para servirem como opções de clonagem
     * 
     * @param {String|Number} id ID da disponibilidade
     */
    getAvailabilitySalesTable(id) {
        return this.getAll(this.constructor.normalize('/availability_id/', id), {})
    }

    /**
     * Clona uma tabela de vendas de acordo com o ID e retorna os dados da nova tabela clonada
     * 
     * @param {String|Number}
     */
    clone(id) {
        return this.http.post(this.constructor.normalize(this.resource, this.constructor.normalize(id, '/clone')))
            .then(response => {
                if (response.data && response.data.status === 'error') return Promise.reject(response)

                return response
            })
    }

    /**
     * Cria as instâncias de séries/parcelas de um fluxo de uma tabela de vendas, e cria
     * o fluxo caso este não exista
     * 
     * @param {*} data 
     */
    storeFlow(data) {
        return this.http.post('/availability/tableitem/many', { data })
            .then(response => {
                if (response.data && response.data.status === 'error') return Promise.reject(response)

                return response
            })
    }

    /**
     * Atualiza uma instância de fluxos de uma tabela de vendas
     * 
     * @param {String|Number} id 
     * @param {*} data 
     */
    updateFlow(id, data) {
        return this.http.put(this.constructor.normalize('/availability/tableflow', id), { ...data })
            .then(response => {
                if (response.data && response.data.status === 'error') return Promise.reject(response)

                return response
            })
    }

    /**
     * Atualiza as posições de um ou mais fluxos
     * 
     * @param {*} data
     */
    updateFlowPositions(data) {
        return this.http.post('/availability/tableflow/positions', { ...data })
            .then(response => {
                if (response.data && response.data.status === 'error') return Promise.reject(response)

                return response
            })
    }

    /**
     * Remove uma instância de série/parcela de um fluxo
     * 
     * @param {String|Number} id 
     */
    removeItem(id) {
        return this.http.delete(this.constructor.normalize('/availability/tableitem', id))
            .then(response => {
                if (response.data && response.data.status === 'error') return Promise.reject(response)

                return response
            })
    }

    /**
     * Remove uma instância de fluxo de uma tabela de vendas
     * 
     * @param {String|Number} id 
     */
    removeFlow(id) {
        return this.http.delete(this.constructor.normalize('/availability/tableflow', id))
            .then(response => {
                if (response.data && response.data.status === 'error') return Promise.reject(response)

                return response
            })
    }

    /**
     * Busca as regras de commissão de uma tabela de vendas
     * 
     * @param {String|Integer} id
     */
    getCommissionRules(id) {
        return super.getAll(this.constructor.normalize(id, '/commissionRules'), {})
    }

    /**
     * Busca as regras de simulador de uma tabela de vendas
     * 
     * @param {String|Integer} id
     */
    getSimulatorRules (id) {
        return super.getAll(this.constructor.normalize(id, '/simulatorRules'), {})
    }
    getTableConfigurations(){
        return this.http2.get('/availability/sales-table/configurations').then((response) =>{
            if (response.data && response.data.status === 'error') return Promise.reject(response)
            return response
        })
    }
    saveTableConfigurations(data) {
        return this.http2.post('availability/sales-table/configurations', { ...data })
            .then(response => {
                if (response.data && response.data.status === 'error') return Promise.reject(response)

                return response
            }).catch((error) => {
                return Promise.reject(error)
            })
    }
    saveTableGroups(table_id, data){
        return this.http2.post(`/availability/sales-table/permissions/${table_id}`, { ...data })
        .then(response => {
            if (response.data && response.data.status === 'error') return Promise.reject(response)

            return response
        }).catch((error) => {
            return Promise.reject(error)
        })
    }
    getSeries(){
        return this.http2.get('availability/sales-table/parcel-types').then((response) =>{
            if (response.data && response.data.status === 'error') return Promise.reject(response)
            return response.data
        }).catch((error) => {
            return Promise.reject(error)
        })
    }
    updateSeries(payload){
        return this.http2.put('availability/sales-table/parcel-types', payload).then((response) =>{
            if (response.data && response.data.status === 'error') return Promise.reject(response)
            return response.data
        }).catch((error) => {
            return Promise.reject(error)
        })
    }
    updateReadjustableInstallments (sales_table_id, readjust) {
        return this.http2.put('/availability/sales-table/readjust/'+ sales_table_id, {readjust});
    }

    updateInstallmentDates(id, data) {
        return this.update(this.constructor.normalize(id, '/installmentDates'), '', data)
    }
} 
